import React,{useState} from 'react';
import {isAuthenticated} from '../auth/authenticate';
import Layout from '../main/Layout/Layout';
import axios from 'axios';



function AddCategory(props) {
    const [data,setData] = useState({
        name:"",
        image:""
    });
    const [error,setError]=useState('');
    const [success,setSuccess]=useState(false);

    const{name} = data;
    const handleChange =name=>event=>{
        setError(false);
        setSuccess(false);
        setData({...data,[name]:event.target.value});
    }


    const clickSubmit =(event)=>{
        event.preventDefault();
        setError(false);
        setSuccess(false);
        const options = {
            url:'/category/create',
            method: 'POST',
            headers: { Authorization: 'Bearer ' + isAuthenticated().data.token },
            data: data,// This is the body part
          };
        axios(options)
        .then(data=>{
            setSuccess(true);
            setError(false);
        }).catch(err=>{ 
            console.log(err)
            setError(err.response.data.message);
        })
        
    }

    const showError=()=>(
        error&&(
        <div className="alert alert-danger">{error}</div>
        )
    )

    const showSuccess=()=>(
        success&&(<div className="alert alert-success">{name} created success</div>)
    )

    return (
        <React.Fragment>
            <Layout/>
            <br/>
            <div className="container" style={{backgroundColor:"#e5e5e5",borderRadius:"10px"}}>
                {showError()}
                {showSuccess()}
                <form className="my-5 p-4">
                    <div className="form-group">
                        <label htmlFor="category">Category</label>
                        <input id ="category" onChange={handleChange('name')} type="text"  className="form-control" aria-describedby="cateHelp" placeholder="add category name"/>
                        <small id="cateHelp" className="form-text text-muted">Add category name</small>
                    </div>
                    <div className="form-group">
                        <label htmlFor="link">Link image</label>
                        <input id ="link" onChange={handleChange('image')} type="text"  className="form-control" aria-describedby="cateHelp" placeholder="add category name"/>
                        <small id="cateHelp" className="form-text text-muted">Add product id take from product to get link image</small>
                    </div>
                        <button onClick={clickSubmit} className="btn btn-primary">Create category</button>
                </form>
            </div>
        </React.Fragment>
    );
}

export default AddCategory;